import type { MetricTooltipEventProperties } from '../events'
import { trackAnalyticsEvent } from '../track'

export function trackMetricTooltipOpenChange(
  isOpen: boolean,
  properties: MetricTooltipEventProperties
) {
  if (!isOpen) return

  trackAnalyticsEvent('metric_tooltip_opened', properties)
}
